import styled from 'styled-components';

export const ClickableText = styled.span`
  color: #667eea;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #5a67d8;
    text-decoration: underline;
  }
`;